import React, { useEffect, useState } from 'react';
import useCountUp from './useCountUp';
import './market.css';

/**
 * Replaces the order ticket in place the moment a trade fills — no modal,
 * nothing blocking. `tone` drives the color: 'you' (orange) for an opening
 * fill, 'profit'/'loss' (green/red) for a close, matching the house rule
 * that orange means you and green/red mean a real, realized outcome.
 */
const FillMoment = ({ nonce, tone, title, heroTarget, heroFormat, heroDecimals = 0, sub, line, onShare, onDone }) => {
  const display = useCountUp(heroTarget, { duration: 650, initial: 0 });
  const [showShare, setShowShare] = useState(false);

  useEffect(() => {
    setShowShare(false);
    if (!onShare) return undefined;
    const t = setTimeout(() => setShowShare(true), 900);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nonce]);

  const shown = heroDecimals > 0 ? Number(display.toFixed(heroDecimals)) : Math.round(display);

  return (
    <div className={`mk-fill show ${tone}`}>
      <div className="mk-fill-glow" aria-hidden="true" />
      <div className="mk-fill-title">{title}</div>
      <div className="mk-fill-num mk-mono">{heroFormat(shown)}</div>
      {sub && <div className="mk-fill-sub mk-mono">{sub}</div>}
      {line && <div className="mk-fill-line">{line}</div>}
      {onShare && (
        <button type="button" className={`mk-fill-share${showShare ? ' show' : ''}`} onClick={onShare}>
          Share the ticket →
        </button>
      )}
      <button type="button" className="mk-fill-again" onClick={onDone}>
        Trade again
      </button>
    </div>
  );
};

export default FillMoment;
